import React from 'react';
import { Faq } from '../../components/faq';

export const FaqPage: React.FC = () => <Faq />;
